import React from 'react'
import {Link} from 'react-router-dom'
import {ROUTE_PRICING} from '../utils/routingConstants'

const UpgradeLink = ({className, children = 'Go premium'}) => {
  return <Link className={className} to={ROUTE_PRICING}>{children}</Link>
}

export default UpgradeLink
